import { render, staticRenderFns } from "./dictgroup-add-or-update.vue?vue&type=template&id=3bc77540&"
import script from "./dictgroup-add-or-update.vue?vue&type=script&lang=js&"
export * from "./dictgroup-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports